import React, { useState } from "react";
import style from "./index.module.css";
import closeeye from "../../../Assets/closeeye.svg";
import eye from "../../../Assets/eye.svg";

const FirstForm = ({ handleChange, input }) => {
  return (
    <div>
      <div className={style.iconInput}>
        <input
          type="text"
          placeholder="First Name"
          name="firstName"
          value={input.firstName}
          onChange={handleChange}
          className={style.fir}
          autoComplete="off"
        />
      </div>
      <div className={style.iconInput}>
        <input
          type="text"
          placeholder="Last Name"
          name="lastName"
          value={input.lastName}
          onChange={handleChange}
          className={style.fir}
          autoComplete="off"
        />
      </div>
      <div className={style.iconInput}>
        <input
          type="text"
          placeholder="Email Address"
          name="email"
          value={input.email}
          onChange={handleChange}
          autoComplete="off"
        />
      </div>
      <div className={style.iconInput}>
        <input
          type="text"
          placeholder="Title - Ex. 3D Designer "
          name="jobTitle"
          value={input.jobTitle}
          onChange={handleChange}
          autoComplete="off"
        />
      </div>
    </div>
  );
};

export default FirstForm;
